import 'amfe-flexible'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Cube from 'cube-ui'
import App from './App'
import Axios from 'axios'
import router from './router'
import utils from './components/util.js'
import Vant from 'vant';
import 'vant/lib/index.css';
import FastClick from 'fastclick'
import VueUploadImgs from 'vue-upload-imgs'
import BMap from 'vue-baidu-map'
import AMap from 'vue-amap';
Vue.use(AMap);

 // 初始化vue-amap
AMap.initAMapApiLoader({
 // 高德key
 key: '86fd773a19113517d58ce950c16596cc',
 // 插件集合 （插件按需引入）
 plugin: ['AMap.Geolocation']
});

Vue.use(BMap, {
  ak: 'UffVBQt50idsIugjxByUG6RBnGDeSUd6'
})

Vue.use(VueUploadImgs)
Vue.use(Vant);
Vue.prototype.$utils = utils // main.js中全局引入
Vue.prototype.$point = "" // main.js中全局引入

Vue.use(Cube)


Vue.config.productionTip = false
FastClick.attach(document.body);
Vue.prototype.$axios = Axios

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js